import MultipleItems from "../MultipleItems";
import styles from "./styles.module.scss";

export function Experience() {
  return (
    <section className={styles.ExperienceContainer} id="srollSuave">
      <h2 className="subtitle">
        experiência <span>?</span>
      </h2>
      <div className={styles.MyApps}>
        <h3>
          veja alguns dos meus <br /> projetos pessoais 🚀
        </h3>
        <div>
          <MultipleItems />
        </div>
        <a href="projetos.html" className="linkBtn">
          Veja outros projetos ↗
        </a>
      </div>
    </section>
  );
}
